import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Handker Bandanas (b_9noaizffyc, advertiser 3140156110704377480).
// NEW_ONLY, non-pooled, with complete-month metrics through Aug 2026.
export const advHandkerBandanas: FaireAdvertiserProfileEntity = {
  token: "adv_handker_bandanas",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Handker Bandanas",
  brandToken: "b_9noaizffyc",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 9,
  budget: {
    totalBudgetDollars: 2500,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 194,
    numReorderConversions: 0,
    numTotalConversions: 194,
    totalAdsSalesDollars: 119506,
    newCustomerAdsSalesDollars: 119506,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 14548,
    newCustomerAdsSpendDollars: 14548,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 9.78,
    reorderRoas: 0,
    combinedFirstYearRoas: 9.78,
    numNewCustomerAdsOrders: 364,
    numReorderAdsOrders: 0,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 3240,
      maxRecommendedBudgetDollars: 5240,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 990,
      maxRecommendedBudgetDollars: 1980,
    },
  },
  campaignTokens: ["camp_hb_new"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
